module.exports = __webpack_public_path__ + "static/media/pic2.9e801a93.jpg";